import { css } from '@emotion/css';

export const buttonStyles = css`
  margin-top: 5px;
  width: 60%;
`;
